// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"MapMarker_pattern-gradient__S-l5q","container":"MapMarker_container__p8U6i","marker":"MapMarker_marker__HPVvh","label":"MapMarker_label__LL30A"};